import React from 'react'

export default function StarIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={23}
      height={23}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.6 11.64a1 1 0 00.62-.642l1.536-4.873a.777.777 0 011.482 0l1.536 4.873a1 1 0 00.62.642l4.532 1.598a.852.852 0 010 1.606l-4.531 1.598a1 1 0 00-.621.642l-1.536 4.873a.777.777 0 01-1.482 0l-1.535-4.873a1 1 0 00-.622-.642l-4.53-1.598a.851.851 0 010-1.606l4.53-1.598zM16.11 3.7a1 1 0 00.62-.643l.635-2.014a.777.777 0 011.482 0l.635 2.014a1 1 0 00.621.643l1.829.645a.851.851 0 010 1.606l-1.829.644a1 1 0 00-.621.643l-.635 2.014a.777.777 0 01-1.482 0l-.634-2.014a1 1 0 00-.622-.643l-1.828-.644a.851.851 0 010-1.606l1.828-.645z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}
